<template>
  <div class="bg-base-200">
    <ul class="menu py-3 min-w-full w-full rounded-md">
      <li class="menu-title mt-2">
        <span class="text-base sm:text-lg">Ana Menü</span>
      </li>
      <li>
        <router-link
          to="/book_loans"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath == '/book_loans' ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <span>Ana Sayfa</span>
        </router-link>
      </li>

      
      <li class="menu-title mt-4" v-can="['adminAndSchoolManager']">
        <span class="text-base sm:text-lg">Menü</span>
      </li>

      <li v-can="['adminAndSchoolManager']">
        <router-link
          to="/library_books"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/library_books') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
          </svg>
          <span>Kitaplarım</span>
        </router-link>
      </li>
      <li v-can="['adminAndSchoolManager']">
        <router-link
          :to="`/schools/detail/${currentUser?.school_id}`"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/schools/detail') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
          <span>Öğrenciler</span>
        </router-link>
      </li>
      <li v-can="['adminAndSchoolManager']">
        <router-link
          to="/book_loans/create"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/book_loans/create') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h2m3-4H9a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1m-1 4l-3 3m0 0l-3-3m3 3V3" />
          </svg>
          <span>Ödünç Ver</span>
        </router-link>
      </li>     
      <li v-can="['adminAndSchoolManager']">
        <router-link
          to="/book_loans/list"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/book_loans/list') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
          <span>Ödünç Verilenler</span>
        </router-link>
      </li>
      <li v-can="['adminAndSchoolManager']">
        <router-link
          to="/books/create"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/books/create') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
          <span>Kitap Öner</span>
        </router-link>
      </li>

      
      <li class="menu-title mt-4" v-can="['adminAndSchoolManager']">
        <span class="text-base sm:text-lg">Kurumlar</span>
      </li>
      <li v-can="['adminAndSchoolManager']">
        <router-link
          to="/schools/list"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/schools/list') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          <span>Okullar</span>
        </router-link>
      </li>
      <li v-can="['adminAndSchoolManager']">
        <router-link
          to="/libraries/list"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/libraries/list') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
          </svg>
          <span>Kitaplıklar</span>
        </router-link>
      </li>
      
      <li class="menu-title mt-4" v-can="['admin']">
        <span class="text-base sm:text-lg">Sistem</span>
      </li>
      <li v-can="['admin']">
        <router-link
          to="/books/list"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/books/list') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
          <span>Kitaplar</span>
        </router-link>
      </li>

      <li v-can="['admin']">
        <router-link
          to="/users/list"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/users/list') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <span>Kullanıcılar</span>
        </router-link>
      </li>

      <li v-can="['admin']">
        <router-link
          to="/contacts"
          class="flex items-center py-2.5 px-3 text-sm sm:text-base rounded-lg hover:bg-base-300 dark:hover:bg-neutral-700 transition-colors"
          :class="[route.fullPath.includes('/contacts') ? 'bg-primary/10 text-primary font-medium' : '']"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span>İletişim</span>
        </router-link>
      </li>

    </ul>
  </div>
</template>


<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import store from "../../store";

const route = useRoute();

const currentUser = computed(() => {
  return store.getters._getCurrentUser;
});

</script>

<style scoped>
@media (max-width: 640px) {
  .menu li a {
    min-height: 3rem;
  }
}

.menu-title {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  opacity: 0.6;
  font-weight: 600;
}
</style>